import { render, staticRenderFns } from "./MarketTypeTable.vue?vue&type=template&id=104d731c"
import script from "./MarketTypeTable.vue?vue&type=script&lang=js"
export * from "./MarketTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports